import React from 'react';

const Edit = () => {
    return (
        <div>
            Edit video
        </div>
    );
};

export default Edit;